import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import BroadcastsView from './BroadcastsView.vue';
import BroadcastsList from './BroadcastsList.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.BROADCASTS,
  permissions: ['administrator', 'agent'],
};

const metaAdmin = {
  featureFlag: FEATURE_FLAGS.BROADCASTS,
  permissions: ['administrator'],
};

const broadcastsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/broadcasts'),
      component: BroadcastsView,
      meta,
      children: [
        {
          path: '',
          name: 'broadcasts_list',
          component: BroadcastsList,
          meta,
        },
        {
          path: 'new',
          name: 'broadcasts_new',
          component: () => import('./wizard/BroadcastWizard.vue'),
          meta,
        },
        {
          path: 'blacklist',
          name: 'broadcasts_blacklist',
          component: () => import('./BroadcastBlacklist.vue'),
          meta: metaAdmin,
        },
        {
          path: 'engagement',
          name: 'broadcasts_engagement',
          component: () => import('./BroadcastEngagement.vue'),
          meta,
        },
        {
          path: ':broadcastId/edit',
          name: 'broadcasts_edit',
          component: () => import('./wizard/BroadcastWizard.vue'),
          meta,
        },
        {
          path: ':broadcastId',
          name: 'broadcasts_detail',
          component: () => import('./BroadcastDetail.vue'),
          meta,
        },
      ],
    },
  ],
};

export default broadcastsRoutes;
